import React from "react"
import { graphql, Link } from "gatsby"
import TimeAgo from "timeago-react"
import RecentImageBlob from "../components/recentimageblob"
import Layout from "gatsby-theme-wirehead-bulma/src/layout"
import SEO from "gatsby-theme-wirehead-bulma/src/seo"
import GenerateBlogList from "../components/bloglist"
import RecentBlogsBlob from "../components/recentblogsblob"

const BlogPage = ({
  data: {
    blogs: { edges }
  },
  pageContext,
  location,
}) => {


  const { pathPrefix, pageNumber, humanPageNumber, numberOfPages, previousPagePath, nextPagePath } = pageContext

  let firstLink = <span />
  let lastLink = <span />
  let nextPriLink = <span />
  let prevPriLink = <span />
  let nextLink = <span />
  let prevLink = <span />
  let firstElipse  = <span />
  let secondElipse  = <span />
  const currentPagePath = <Link className="pagination-link" to={location.pathname}>
        {humanPageNumber}
      </Link>
  if (pageNumber > 1) {
    firstLink = <Link className="pagination-link" to={pathPrefix}>
        1
      </Link>
  }
  if (pageNumber > 2) {
    firstElipse  = <span className="pagination-ellipsis">&hellip;</span>
  }
  if (previousPagePath) {
    prevLink = (
      <Link className="pagination-link" to={previousPagePath} rel="prev">
        {humanPageNumber-1}
      </Link>
    )
    prevPriLink = (
      <Link className="pagination-previous" to={previousPagePath} rel="prev">
        Previous
      </Link>
    )
  }
  if (pageNumber < numberOfPages-3) {
    secondElipse  = <span className="pagination-ellipsis">&hellip;</span>
  }
  if (nextPagePath) {
    if (pageNumber < numberOfPages-2) {
      lastLink = <Link className="pagination-link" to={pathPrefix + `/${numberOfPages}`}>
          {numberOfPages}
        </Link>
    }
    nextLink = (
      <Link className="pagination-link" to={nextPagePath} rel="next">
        {humanPageNumber+1}
      </Link>
    )
    nextPriLink = (
      <Link className="pagination-next" to={nextPagePath} rel="next">
        Next
      </Link>
    )
  }

  return (<Layout>
    <SEO pathname={location.pathname} title={pageContext.title} />
    <section className="section">
    <div className="columns">
      <div className="column">
      </div>
      <div className="column is-two-thirds">
      <GenerateBlogList edges={edges} summary={true} />
      <nav className="pagination" role="navigation" aria-label="pagination">
      {prevPriLink}
      {nextPriLink}
      <div className="pagination-list">
      {firstLink}
      {firstElipse}
      {prevLink}
      {currentPagePath}
      {nextLink}
      {secondElipse}
      {lastLink}
      </div>
      </nav>
      </div>
      <div className="column">
        <hr
          style={{ backgroundColor: "#888", height: "3px" }}
          className="is-hidden-desktop"
        />
        <div className="sideblock is-clearfix">
        <h3>Recent Images:</h3>
        <RecentImageBlob />
        </div>
      </div>
    </div>
    </section>
  </Layout>);
}

export default BlogPage

export const pageQuery = graphql`
  query blogListQuery($skip: Int!, $limit: Int!, $pathPrefix: String) {
    blogs: allSitePage(
      sort: { fields: context___date, order: DESC }
      filter: { context: { date: {ne: null}, hidden: {ne: true}, parent: { eq: $pathPrefix } } }
      limit: $limit
      skip: $skip
    ) {
      edges {
        node {
          id
          path
          context {
            id
            name
            parent
            title
            type
            depth
            date
            excerpt
            url
          }
        }
      }
    }
  }
`


export const frontmatter = {
  title: "Blog",
}